module.exports = __webpack_public_path__ + "img/50-50.5f7aa2e8.svg";